module.exports = __webpack_public_path__ + "static/media/WhatsApp.5118957b.jpg";